<template>
  <div class="col-12 banner-title">
    <img
      src="https://cdn.proxyscrape.com/img/logo/dark_text_logo.png"
      alt="dark proxyscrape logo"
      style="width: 20%; min-width: 170px"
    />
  </div>

  <div class="row finaladv w-100">
    <div class="col-12">
      <div class="itemcard downloadcard">
        <div class="row">
          <div class="col-2">
            <img src="@/assets/img/svg/proxy-datacenters.svg" />
            <h2>50 000 datacenter proxies</h2>
          </div>
          <div class="col-3">+</div>

          <div class="col-2">
            <img src="@/assets/img/svg/unlimited-bandwidth.svg" />
            <h2>Unlimited bandwidth</h2>
          </div>
          <div class="col-3">+</div>
          <div class="col-2">
            <img src="@/assets/img/svg/uptime-100.svg" />
            <h2>99% uptime</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center"><a class="btn" href="#services">Start now</a></div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped src="../../assets/css/home.css"></style>
